import type { CalendarDateRange } from 'src/modules/shared/types/date-range.type';

/** Stable preset identifiers for execution date filtering. */
export const ExecutionDatePreset = {
  TODAY: 'today',
  LAST_7_DAYS: 'last-7-days',
  LAST_30_DAYS: 'last-30-days',
} as const;

/** One execution date-range shortcut. */
export type ExecutionDatePresetId =
  (typeof ExecutionDatePreset)[keyof typeof ExecutionDatePreset];

/** ISO timestamp query sent to the execution API. */
export interface ExecutionDateQuery {
  /** Inclusive first instant. */
  from?: string;
  /** Inclusive final instant. */
  to?: string;
}

/** Calendar filter stored in the route search parameters. */
export type ExecutionCalendarDateRange = CalendarDateRange;
